<ng-container *ngIf="!!notifications && notifications.length != 0; else noNotifications">
  <ng-container *ngFor="let notification of notifications">
    <app-notification [notification]="notification"></app-notification>
  </ng-container>
</ng-container>

<ng-template #noNotifications>
  <div class="no-notifications">{{__('noNotifications')}}</div>
</ng-template>
